import { registerStores } from './ui/stores';
import { registerOverlay } from './ui/overlay';
import { registerSelect } from './ui/select';
import { registerInline } from './ui/inline';
import { registerTabs } from './ui/tabs';
import { registerShortcuts } from './ui/shortcuts';
import { theme } from './ui/theme';

window.bootstrap = require('bootstrap/dist/js/bootstrap.bundle.js');
window.nnTheme = theme;

// Alpine wird von Livewire mitgeliefert und gestartet; eigene Bausteine werden vorher registriert.
document.addEventListener('alpine:init', () => {
    registerStores(Alpine);
    registerOverlay(Alpine);
    registerSelect(Alpine);
    registerInline(Alpine);
    registerTabs(Alpine);
});

registerShortcuts();

// wire:navigate übernimmt die Attribute von <html> aus der neuen Seite und würde
// damit Design und eingeklappte Seitenleiste verwerfen – direkt nach dem Tausch wieder setzen.
document.addEventListener('alpine:navigating', (event) => {
    event.detail.onSwap(() => {
        window.nnTheme.apply();
        if (window.Alpine?.store('sidebar')?.collapsed) {
            document.documentElement.setAttribute('data-nn-sidebar', 'collapsed');
        }
    });
});

// Beim Seitenwechsel per wire:navigate das mobile Menü schließen
document.addEventListener('livewire:navigating', () => {
    const sidebar = document.getElementById('nnSidebar');
    window.bootstrap.Offcanvas.getInstance(sidebar)?.hide();
    document.querySelectorAll('.offcanvas-backdrop').forEach((el) => el.remove());
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('padding-right');
});
